import React from "react";
import { motion } from "framer-motion";

const ModernBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden bg-[#f13b3b]">
      {/* Ultra subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 via-white to-cyan-50/30" />
      
      {/* Modern grid pattern */}
      <div className="absolute inset-0 opacity-20">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
              linear-gradient(#e5e7eb 1px, transparent 1px),
              linear-gradient(90deg, #e5e7eb 1px, transparent 1px)
            `,
            backgroundSize: "80px 80px",
          }}
        />
      </div>

      {/* Floating elements */}
      <motion.div
        className="absolute top-1/4 -left-4 w-96 h-96 bg-gradient-to-br from-blue-100/40 to-transparent rounded-full blur-3xl"
        animate={{
          scale: [1, 1.1, 1],
          opacity: [0.3, 0.5, 0.3],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      
      <motion.div
        className="absolute -bottom-32 -right-16 w-80 h-80 bg-gradient-to-tr from-cyan-100/30 to-transparent rounded-full blur-3xl"
        animate={{
          scale: [1.1, 1, 1.1],
          opacity: [0.4, 0.2, 0.4],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 2,
        }}
      />

      {/* Subtle animated dots */}
      {[...Array(12)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-2 h-2 bg-blue-200/40 rounded-full"
          animate={{
            scale: [0, 1, 0],
            opacity: [0, 0.6, 0],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            delay: i * 0.3,
            ease: "easeInOut",
          }}
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
          }}
        />
      ))}

      {/* Corner accents */}
      <div className="absolute top-8 left-8 w-4 h-4 border-t-2 border-l-2 border-blue-200/50" />
      <div className="absolute top-8 right-8 w-4 h-4 border-t-2 border-r-2 border-cyan-200/50" />
      <div className="absolute bottom-8 left-8 w-4 h-4 border-b-2 border-l-2 border-blue-200/50" />
      <div className="absolute bottom-8 right-8 w-4 h-4 border-b-2 border-r-2 border-cyan-200/50" />
    </div>
  );
};

export default ModernBackground;